"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _xml = _interopRequireDefault(require("highlight.js/lib/languages/xml"));

var _default = _xml.default;
exports.default = _default;